
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cgu",
      function () {
        return require("private-next-pages/cgu/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cgu"])
      });
    }
  